import React from 'react';

import useDispensaryProximity from '../dispensaries/useDispensaryProximity';
import SecondaryHeader from '../styleguide/SecondaryHeader';
import DispensaryCard from '../dispensaries/DispensaryCardTall';
import AddressInputSection from '../address/AddressInputSection';
import Spinner from '../common/Spinner';
import DelayContent from '../common/DelayContent';
import PropTypes from 'prop-types';

import styles from '../dispensaries/Dispensaries.module.css';

const PickupDispensarySection = ({
  setSearchLocation, /* for address prompt */
}) => {
  
  const headerText = 'Featured Dispensaries'; 
  const { dispensariesByDistance, distanceMap, loading:proximityLoading } = useDispensaryProximity();

  // travel distance from user's address to dispensary
  const getTravelDistance = (dispId) => {
    return distanceMap ? distanceMap.get(dispId) : null;
  } 

  return ( proximityLoading
    ? <Spinner />
    : dispensariesByDistance?.length > 0
      ? <>
          <SecondaryHeader text={headerText} />
          <div className={styles.dispensaryList}>
            { dispensariesByDistance.map((disp, idx) => {
              return <DispensaryCard
                       key={disp.id}
                       dispensaryId={disp.id}
                       dispensaryName={disp.name}
                       dispensaryLogo={disp.image_urls.secondary}
                       createDate={disp.created_at}
                       dispensaryLocation={disp.location}
                       travelDistance={getTravelDistance(disp.id)}
                       isPickup />
            })}
          </div>
        </>  
      : <DelayContent delayMS={1000}> 
          <SecondaryHeader text="Shop Nearby Dispensaries" />
          <AddressInputSection onAddressSelect={setSearchLocation} />
        </DelayContent>
      
  );
}

PickupDispensarySection.propTypes = {
  setSearchLocation: PropTypes.func.isRequired
}

export default PickupDispensarySection;